import type { TherapistStore } from "../Store";

import TherapistApiConnector from "@/Services/TherapyApi/Therapists";
import TherapistApiToTherapistTransformer from "@/Modules/Transformers/Therapist/TherapistApiToTherapist";
import type { TherapistStripeAccount } from "@/Modules/Models/Domain/Therapist";

class SetTherapistActionHandler {
  constructor(
    private readonly therapistStore: TherapistStore,
    private readonly therapistApiConnector = new TherapistApiConnector(),
    private readonly therapistApiToTherapistTransformer = new TherapistApiToTherapistTransformer()
  ) {}

  public async handle() {
    const therapistApi = await this.therapistApiConnector.get();
    const therapist = this.therapistApiToTherapistTransformer.transform(therapistApi);

    this.therapistStore.therapist = therapist;

    if (therapist.isStripeConnectAvailable) {
      const stripeAccount: TherapistStripeAccount = await this.therapistStore.updateStripeAccount();

      this.therapistStore.stripeAccountLink = stripeAccount.accountLink;
    }
  }
}

export default SetTherapistActionHandler;
